/**
 * Génère une Idempotency-Key UUID v4 à envoyer en header HTTP sur les POST
 * de création de paiement (Stripe + PayPal). Pattern industriel Stripe.
 *
 * À utiliser :
 * ```ts
 * import { generateIdempotencyKey } from "~/utils/idempotencyKey";
 * await $fetch(url, {
 *   method: "POST",
 *   headers: { "Idempotency-Key": generateIdempotencyKey() },
 *   body,
 * });
 * ```
 *
 * Le backend cache la réponse 24h ; si le client retry avec la MÊME clé
 * (double-clic, retry réseau, app crashed mid-flight), il reçoit la réponse
 * cachée au lieu de créer un 2e order/payment intent.
 *
 * On utilise `crypto.randomUUID()` (Web Crypto API, dispo navigateurs modernes
 * et Node 19+). Fallback Math.random pour vieux navigateurs en SSR.
 */

export function generateIdempotencyKey(): string {
  if (
    typeof globalThis.crypto !== "undefined" &&
    typeof globalThis.crypto.randomUUID === "function"
  ) {
    return globalThis.crypto.randomUUID();
  }
  // Fallback non-crypto (suffisant pour identifier une session de paiement,
  // pas pour de la sécurité).
  return `idem-${Date.now()}-${Math.random().toString(36).substring(2, 15)}-${Math.random().toString(36).substring(2, 15)}`;
}
